import { render } from "./DiagnosisTableRow.vue?vue&type=template&id=b8ec84aa"
import script from "./DiagnosisTableRow.ts?vue&type=script&lang=js&external"
export * from "./DiagnosisTableRow.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__